import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-button-group',
	templateUrl:'./WaButtonGroupPage.html',
	styles: [],
	styleUrls:['./WaButtonGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaButtonGroupPage
{
	mdContent_286 = `\`\`\`java
import com.jwebmp.webawesome.components.button.WaButtonGroup;
\`\`\``;
	mdContent_287 = `\`\`\`java
var group = new WaButtonGroup<>();
group.add(new WaButton<>("One", Variant.Brand));
group.add(new WaButton<>("Two", Variant.Brand));
group.add(new WaButton<>("Three", Variant.Brand));
\`\`\``;
}
